import { Component } from '@angular/core';
import { ShiftsService } from 'app/services/shifts.service';

@Component({
  selector: 'app-turnos-list',
  templateUrl: './turnos-list.component.html',
  styleUrls: ['./turnos-list.component.css']
})
export class TurnosListComponent {

  turnos = [];

  constructor(
    private turnoService: ShiftsService,
  ) {
    const sidebar = <HTMLElement>document.querySelector(".navbar-brand");
    if (sidebar !== undefined) {
      sidebar.innerHTML = "Turnos";
    }
    this.getTurnos();
  }

  getTurnos() {
    this.turnoService.getTurnos().subscribe(
      (resp: any) => {
        this.turnos = resp;
      },
      (error) => {
        console.error(error);
      }
    );
  }

  deleteTurnos(turno) {
    this.turnoService.deleteTurno(turno.id).subscribe(
      (resp: any) => {
        this.getTurnos();
      },
      (error) => {
        console.error(error);
      }
    );
  }

}
